"use strict";
// Options that come from the property_field_options table (see SchemaService)
// carry their own translations and the property types they apply to.
// Options written in the form config have neither and keep using i18n keys.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOptionForType = exports.toOptionLabels = exports.pickOptionLabel = void 0;
// Label in the site language; Armenian is always filled in Nova, so it is the fallback.
var pickOptionLabel = function (labels, language) { return labels[language] || labels.hy || ''; };
exports.pickOptionLabel = pickOptionLabel;
// Stored value(s) -> labels of the table options ("residential" -> "Под жилое
// строительство"). Values of fields without table options come back unchanged,
// so the existing FIELD_OPTIONS translation keeps handling them.
var toOptionLabels = function (data, options, language) {
    var tableOptions = (options || []).filter(function (o) { return o.labels; });
    if (!tableOptions.length || data === undefined || data === null) {
        return data;
    }
    var labelOf = function (value) {
        var option = tableOptions.find(function (o) { return o.text === value; });
        return (option === null || option === void 0 ? void 0 : option.labels) ? exports.pickOptionLabel(option.labels, language) : value;
    };
    return Array.isArray(data) ? data.map(labelOf) : labelOf(data);
};
exports.toOptionLabels = toOptionLabels;
// No property types means the option is offered for every type.
var isOptionForType = function (option, propertyType) {
    var _a;
    return !((_a = option.propertyTypes) === null || _a === void 0 ? void 0 : _a.length) ||
        !propertyType ||
        option.propertyTypes.includes(propertyType);
};
exports.isOptionForType = isOptionForType;
